/** "sofia.struempfler@finn.com" → matches an owner named "Sofia Strümpfler" (umlauts folded). */
export function isMine(owner: string | null, email: string) {
  if (!owner) return false;
  const fold = (s: string) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ü/g, 'ue');
  const [first, last] = email.split('@')[0].split('.');
  const o = fold(owner);
  return Boolean(first && o.includes(first)) && (!last || o.includes(last.replace(/ue/g, 'u')) || o.includes(last));
}
